import {Directive, forwardRef, Input, OnInit} from '@angular/core';
import {FormControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {FondsVermittlerspezifischesPortfolio} from '../models/fondsVermittlerspezifischesPortfolio';
import {FondsService} from '../services/fonds.service';
import {take} from 'rxjs/operators';

@Directive({
    selector: '[lvPortfolioNameValidator]',
    providers: [
        {
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PortfolioNameValidatorDirective),
        },
    ],
    standalone: false
})
export class PortfolioNameValidatorDirective implements Validator, OnInit {

  private _vermittlerspezifischePortfolios: FondsVermittlerspezifischesPortfolio[];

  constructor(private _fondsService: FondsService) {}

  ngOnInit() {
    this._fondsService.getGespeicherteVermittlerspezifischePortfolios().pipe(take(1)).subscribe(data =>
        this._vermittlerspezifischePortfolios = data);
  }

  validate(control: FormControl): {} {
    if (!control.value || !this._vermittlerspezifischePortfolios) {
      return null;
    }
    const allPortfolioNames: string[] = [];
    this._vermittlerspezifischePortfolios.forEach(fonds => allPortfolioNames.push(fonds.name.toLowerCase()));
    if (!allPortfolioNames.includes(control.value.toLowerCase())) {
      return null;
    }
    return {ERROR: 'PORTFOLIO_NAME_BEREITS_VERGEBEN'};
  }
}
